// src/pages/KnowledgeBase/Support.jsx
import React from 'react';

export default function Support() {
  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-semibold text-brand1">Contact support</h1>
      <div className="rounded-2xl border border-app bg-app text-app p-5 shadow-sm space-y-3">
        <p className="text-app">
          Need help? Send details, include screenshots if possible.
        </p>
        <ul className="list-disc pl-5 text-sm text-app space-y-1">
          <li>
            Email:{' '}
            <a
              className="underline text-[hsl(var(--primary))] hover:opacity-90"
              href="mailto:support@core2tek.com"
            >
              support@core2tek.com
            </a>
          </li>
          <li>Hours: 8:00–6:00 Central Time, Monday–Friday</li>
          <li>For urgent issues, include “Urgent” in the subject</li>
        </ul>
      </div>
    </div>
  );
}
